import emojiRegex from "emoji-regex";

export const restrictCharacters = (e, restrictedChars = ['~', '^', '*', '_', '`', '[', '"', '<','>', '/','\\', "'",]) => {
    if (restrictedChars.includes(e.key)) {
      e.preventDefault(); // Prevent the restricted character from being entered
    }
  };


// emojiUtils.js

// Function to get graphemes (characters) from the text
export const getGraphemes = (text) => {
  const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
  return Array?.from(segmenter.segment(text), (segment) => segment.segment);
};

// Function to check if a character is an emoji
//export const isEmoji = (char) => /\p{Extended_Pictographic}/u.test(char);
const regex = emojiRegex();

export const isEmoji = (char) => {
  if (typeof char !== "string") return false;
  const matches = [...char.matchAll(regex)];
  return matches.length > 0;
};


// export const isEmoji = (char) => regex.test(char);


  

